
import { css } from 'lit';
export default css`
:host {
  display: block;
  overflow: hidden;
  position: relative;
  width: calc(100% + 2rem);
  left: -1rem;
}
  
  @media (min-width: 1024px) {:host {
    /* full-bleed */
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
  }

.splide {
  margin-bottom: 85px;
  padding-bottom: 75px;
}

.splide__arrows {
  right: 0px;
  z-index: 10;
  margin: auto;
  height: auto;
  width: auto;
  border-width: 0px;
  background-color: transparent;
  max-width: 65%;
}

@media (min-width: 1024px) {

.splide__arrows {
    display: none;
  }
  }

.splide__arrows .splide__arrow {
  height: 1rem;
}

.splide__arrows .splide__arrow {
  width: 1.5rem;
}

.splide__arrows .splide__arrow {
  padding: 0px;
}

.splide__arrows .splide__arrow {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.splide__arrows .splide__arrow--prev {
  justify-content: flex-start;
}

@media (min-width: 768px) {

.splide__arrows .splide__arrow--prev {
        margin-left: 10%
    }
      }

@media (min-width: 1200px) {

.splide__arrows .splide__arrow--prev {
        margin-left: 36%
    }
      }

.splide__arrows .splide__arrow--next {
  justify-content: flex-end;
}

@media (min-width: 768px) {

.splide__arrows .splide__arrow--next {
        margin-right: 10%
    }
      }

@media (min-width: 1200px) {

.splide__arrows .splide__arrow--next {
        margin-right: 36%
    }
      }

.splide__arrows .splide__arrow[disabled] {
  --tw-text-opacity: 1;
  color: rgba(164, 167, 171, var(--tw-text-opacity));
}

.splide__arrows .splide__arrow--icon {
  width: 1rem;
}

.splide__pagination {
  z-index: 20;
  display: none;
  align-items: center;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 0px;
  margin-top: 53px;
}

.splide__pagination__page {
  cursor: pointer;
}

.splide__pagination__page {
  border-width: 0px;
}

.splide__pagination__page {
    background: #C4C4C4; /* new color I guess? or should we stick to one of our greys? */
    border-radius: 50%;
    width: 14px;
    height: 14px;
    margin: 12px 12px 0px;
  }

.splide__pagination__page.is-active {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

@media (min-width: 1024px) {

.splide__pagination {
    display: flex;
  }
  }

.slide-count {
  display: none;
}

::slotted(img) {
  border-radius: 0;
  margin: 0 auto;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.25);
}`;